export class StreetAddress {
  recipientLine1: string | undefined;
  street1: string;
  street2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;

  constructor(a: Partial<StreetAddress>) {
    //         if (a.recipientLine1 == null)
    //             throw new Error(`Invalid street address in constructor: ${JSON.stringify(a)}
    //  recipientLine1 cannot be null`);
    if (a.street1 == null)
      throw new Error(`Invalid street address in constructor: ${JSON.stringify(a)}
 street1 cannot be null`);
    if (a.street2 == null)
      throw new Error(`Invalid street address in constructor: ${JSON.stringify(a)}
 street2 cannot be null`);
    if (a.city == null)
      throw new Error(`Invalid street address in constructor: ${JSON.stringify(a)}
 city cannot be null`);
    if (a.state == null)
      throw new Error(`Invalid street address in constructor: ${JSON.stringify(a)}
 state cannot be null`);
    if (a.postalCode == null)
      throw new Error(`Invalid street address in constructor: ${JSON.stringify(a)}
 postalCode cannot be null`);
    if (a.country == null)
      throw new Error(`Invalid street address in constructor: ${JSON.stringify(a)}
 country cannot be null`);

    this.recipientLine1 = a.recipientLine1;
    this.street1 = a.street1;
    this.street2 = a.street2;
    this.city = a.city;
    this.state = a.state;
    this.postalCode = a.postalCode;
    this.country = a.country;
  }

  public get formattedHTMLAddress(): string {
    let recipientLine1 =
      this.recipientLine1 !== '' ? this.recipientLine1 + '<br/>' : '';
    let street1 = this.street1 !== '' ? this.street1 + '<br/>' : '';
    let street2 = this.street2 !== '' ? this.street2 + '<br/>' : '';
    let cityStatePostalCode =
      this.city !== '' && this.state !== '' && this.postalCode !== ''
        ? this.city + ', ' + this.state + ' ' + this.postalCode + '<br/>'
        : '';
    let country = this.country !== '' ? this.country + '<br/>' : '';

    return recipientLine1 + street1 + street2 + cityStatePostalCode + country;
  }

  static createEmpty(): Partial<StreetAddress> {
    return new StreetAddress({
      recipientLine1: '',
      street1: '',
      street2: '',
      city: '',
      state: '',
      postalCode: '',
      country: '',
    });
  }

  public static clone(a: Partial<StreetAddress>): Partial<StreetAddress> {
    return JSON.parse(JSON.stringify(a));
  }

  public get isEmpty(): boolean {
    return (
      this.recipientLine1 == '' &&
      this.street1 == '' &&
      this.street2 == '' &&
      this.city == '' &&
      this.state == '' &&
      this.postalCode == '' &&
      this.country == ''
    );
  }
}
